"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializeAuthorization = initializeAuthorization;
function initializeAuthorization(application, authorizationFactory) {
    application.authorization = authorizationFactory(application.settings, application.logger);
    return application.authorization.getAuthorizationPromise();
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorizationIntegration.js
// module id = 1324
// module chunks = 118